import ContainerFlex, { PrintableBodyWrapper } from "components/ContainerFlex";
import { useRef } from "react";

import * as St from "./styles";
import { hideCpf, moneyMask } from "utils/mask";
import moment from "moment";
import { getItemLocalStore } from "utils/storeUtils";
import { LOCAL_STORE_CLIENTE } from "../../../../../../constants";
import { useAppSelector } from "redux/app/hooks";

const PrintSummary = () => {
  const componentRef = useRef<HTMLDivElement>(null);

  const { cpf, nome } = getItemLocalStore(LOCAL_STORE_CLIENTE);

  const {
    cliente: {
      valuePaymentInvoice,
      paymentInvoice,
      invoiceInstallmentCalculation,
    },
  } = useAppSelector((state) => state.cliente);
  const { typeFlow } = useAppSelector((state) => state.security);

  const hoje = new Date();
  const diaAtual = moment(hoje).format("DD/MM/YYYY");
  const valorTaxaServico =
    typeFlow === "fatura-pagamento-debito"
      ? 0
      : invoiceInstallmentCalculation?.taxaServico;

  return (
    <PrintableBodyWrapper ref={componentRef}>
      <ContainerFlex row>
        <St.TitleFaturaTextValue>
          Resumo do Pagamento com cartão de crédito
        </St.TitleFaturaTextValue>
        <St.DateFaturaTextValue>Data: {diaAtual}</St.DateFaturaTextValue>
      </ContainerFlex>
      <ContainerFlex row>
        <ContainerFlex>
          <St.SpanTextTitleBold>Cliente:</St.SpanTextTitleBold>
          <St.SpanTextTitle>{nome}</St.SpanTextTitle>
        </ContainerFlex>
        <ContainerFlex end align="flex-end">
          <St.SpanTextTitleBold>CPF:</St.SpanTextTitleBold>
          <St.SpanTextTitle>{hideCpf(cpf)}</St.SpanTextTitle>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />

      <St.TitleFaturaTextValue>Resumo da fatura atual</St.TitleFaturaTextValue>
      <ContainerFlex row>
        <St.SpanTextTitle>Vencimento:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>
            {moment(paymentInvoice?.dataVencimento).format("DD/MM/YYYY")}
          </St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>{`Status: ${paymentInvoice?.statusDescricao}`}</St.SpanTextTitle>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Valor total:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>
            {moneyMask(paymentInvoice?.lancamentoFaturaAtual)}
          </St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Valor mínimo:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>
            {moneyMask(paymentInvoice?.valorMinimoRecebido)}
          </St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />

      <St.TitleFaturaTextValue>Resumo do pagamento</St.TitleFaturaTextValue>
      <ContainerFlex row>
        <St.SpanTextTitle>Valor selecionado:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>
            {moneyMask(Number(valuePaymentInvoice))}
          </St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>{`Taxa de serviço de ${valorTaxaServico}%:`}</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>
            {moneyMask(invoiceInstallmentCalculation?.valorTaxaServico)}
          </St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex row>
        <St.SpanTextTitle>Valor de Pagamento:</St.SpanTextTitle>
        <ContainerFlex end align="flex-end">
          <St.SpanTextValue>
            {moneyMask(invoiceInstallmentCalculation?.valorTotal)}
          </St.SpanTextValue>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />

      <St.TitleFaturaTextValue>{`O pagamento de ${moneyMask(
        invoiceInstallmentCalculation?.valorTotal
      )} pode ser parcelado em até ${
        invoiceInstallmentCalculation?.parcelas
      }x *`}</St.TitleFaturaTextValue>
      {invoiceInstallmentCalculation &&
        invoiceInstallmentCalculation.detalhesParcelas?.map(
          (invoiceInstallmentLine) => (
            <ContainerFlex>
              <St.SpanTextTitle>{`${
                invoiceInstallmentLine.parcelas
              }x de ${moneyMask(
                invoiceInstallmentLine.valor
              )}`}</St.SpanTextTitle>
            </ContainerFlex>
          )
        )}
      <br />
      <St.SpanTextTitle>{`*com taxa de juros de ${invoiceInstallmentCalculation?.taxaJuros}% a.m.`}</St.SpanTextTitle>
      <St.Dividers />
    </PrintableBodyWrapper>
  );
};

export default PrintSummary;
